export const ENUM_RESPONSE_STATUS = {
  APPROVED: 'APPROVED',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
  DECLINED: 'DECLINED',
  UNCONFIRMED: 'UNCONFIRMED',
  PENDING_ID_VERIFICATION: 'PENDING_ID_VERIFICATION',
  REVIEW: 'REVIEW',
  PENDING: 'PENDING',
};

export const ENUM_PAYMENT_PROCESSOR_IDS = {
  NO_ACTIVE_PROCESSOR: 0,
  WIRES: 1,
  CASH_TO_TOKENS: 2,
  WESTERN_UNION: 3,
  PAYONEER: 4,
  EPOCH: 5,
  ACH: 6,
  PAXUM: 7,
  EPAY: 8,
  CROSS_CARD: 9,
  SEGPAY: 12,
  OTHER_PROCESSOR_SIGNUP_GROUP: 10,
  OTHER_PROCESSOR_AFO: 11,
  SOCIALE: 5,
  BITSAFE: 12,
  CA_DIRECT_DEPOSIT: 13,
  OTHER_PROCESSOR_PINGUINO: 14,
  JUICY_SERVICE: 17,
};

export const ENUM_HOLDER_ACCOUNT = {
  PERSONAL: 'Personal',
  BUSINESS: 'Business',
};

export const ENUM_ACCOUNT_TYPE = {
  SAVINGS: 'Savings',
  CHECKING: 'Checking',
};

export const ENUM_PAYMENT_RESPONSE_DATA = { REQUEST_NOT_FOUND: 'REQUEST_NOT_FOUND' };

export const ENUM_ADJUSTMENTS_AND_BONUSES = {
  BONUS: 'bonus',
  ROLLBACK: 'rollback',
  ADJUST: 'adjust',
  ADJUST_USER: 'adjustuser',
  TIP: 'tip',
  OFFLINE_TIP: 'offlinetip',
};

export const PAYMENT_REPLACE = {
  BITSAFE: 'Bitsafe',
  YOURSAFE: 'Yoursafe',
};

export enum EPAY_PRODUCT_TYPES {
  TOKENS = 'TOKENS',
  TOKENSMEMBERSHIP = 'TOKENS-MEMBERSHIP',
  MEMBERSHIP = 'MEMBERSHIP',
  FANCLUB = 'FANCLUB',
  AUTH = 'AUTH',
}

export const TOKEN_PACKAGES_IDS = { FREE_TOKENS: 276 };

export const BITSAFE_DONE_LS_KEY = 'BITSAFE_DONE_LS_KEY';
